import React from 'react'

import cn from 'classnames'

import { content } from './GroupDiscountBanner.content'
import classes from './GroupDiscountBanner.module.scss'
import { Icon } from '../icon/icon'

export const GroupDiscountBanner = ({ className }: { className?: string }) => (
  <div
    className={cn(classes.wrapper, className)}
    data-testid="group-discount-banner"
  >
    <div className={classes.banner}>
      <Icon name="tag" className={classes.tag} />
      {content.bannerText}
      <Icon name="groups" className={classes.groups} />
    </div>
  </div>
)

export default GroupDiscountBanner
